import { fr } from "vuetify/src/locale";

export default {
  ...fr,

  home: "Accueil",
  mainTitle: "CV Julien SUTTER",
  myNameIs: "Bonjour, je m'appelle Julien et je suis",
  iAm: "Ingénieur logiciel full-stack",
  downloadCv: "Télécharger CV",
  frenchCv: "CV en français",
  englishCv: "CV en anglais",
  fullStack: {
    frontend: "Frontend",
    backend: "Backend",
    database: "Base de données",
    english: "Anglais",
    description: {
      business:
        "Je suis dans le métier depuis 10 ans maintenant et j'ai découvert de nombreux langages et frameworks (Java, Hibernate, Spring, Typescript, VueJS, NestJS, Oracle, mongoDB, Couchbase...).",
      today:
        "Aujourd'hui, je me définis comme un développeur Full Stack, capable d'alterner entre fontend, backend et base de données. J'ai pu aussi améliorer la qualité du code avec les principes de clean code et de TDD. J'ai également pû me familiariser avec l'approche DevOps et les micro-services.",
      agile: {
        main:
          "Depuis le début de ma carrière, j'ai toujours travaillé en méthode Agile (Scrum uniquement) et je suis donc imprégné de la culture Agile :",
        1: "Porter son attention sur les échanges et la collaboration",
        2: "Se concentrer sur la qualité du développement du logiciel",
        3: "Travailler ensemble avec les utilisateurs finaux pour faire des tests puis améliorer et corriger",
        4: "Prévoir le changement"
      },
      ux:
        "Je suis aussi très intéréssé par le domaine de l'UX (User Experience) avec la mise en pratique de méthodes telles que les 6to1, la méthode HORSE, l'interview d'utilisateurs, le prototypage...",
      anglais:
        "Travaillant avec des collaborateurs au Portugal, j'ai également l'habitude de travailler en Anglais dans mes projets."
    }
  },
  footer:
    "Ce site internet a été développé en VueJS avec avec la librairie Vuetify",
  waitingMobile:
    "La version mobile arrivera bientôt. Pour l'instant, le mieux est d'utiliser la version bureau.",
  theme: {
    light: "Thème clair",
    dark: "Thème foncé"
  },
  experiences: {
    title: "Expériences",
    previous: "Expérience précédente",
    next: "Expérience plus récente",
    softway: {
      dates: "(Mars 2018 - Aujourd'hui)",
      disrupthor:
        "Projet personnel pour Softway : création d’un outil pour comptabiliser les perturbations durant un sprint et les retranscrire pour les sauvegarder dans notre outil de gestion de projet. Cela permet de voir facilement les équipes qui ont le plus de perturbation.",
      planningpoker:
        "Projet personnel pour Softway : création d’un outil de planning poker suite à la crise du COVID, plutôt que d’utiliser des solutions en ligne. Ce projet m’a permis de faire de la veille technologique et de mettre en pratique les WebSockets.",
      dexther:
        "Implémentation d’une nouvelle base de données médicamenteuse au sein du logiciel. Le logiciel pouvait déjà utiliser deux bases médicamenteuses différentes en fonction de l’affinité du client avec l’une ou l’autre.",
      pmm:
        "Participation au développement d’un nouveau module de prescription multi-modale (médicament, soin, biologie et acte en une seule fois). Ce module était attendu depuis longtemps par les clients. Au début, nous avons collaboré avec l’équipe UX pour proposer le meilleur design possible. Ce projet a ensuite continué en tant qu’équipe étendue avec des prestataires portugais. Je suis alors passé sur un rôle de Scrum Master en plus de mon rôle de développeur. Toute la communication de l’équipe est donc passé en anglais.",
      injectable:
        "Participation au développement de nouvelles fonctionnalités pour la partie prescription du logiciel (nouveau module d’injectable, impression ordonnance de sortie…).",
      offline:
        "Projet de solution de secours pour pouvoir accéder à différentes informations patient même en cas de coupure réseau avec le data center. Cette solution permet de remplacer l’impression de document PDF."
    },
    thales: {
      dates: "(Septembre 2012 - Mars 2018)",
      edf: {
        title: "EDF (Juillet 2017 - Mars 2018)",
        description:
          "Participation à la mise en place d’un socle commun avec frontend en Angular 4 / TS + Cordova et backend en Java. Participation aux développements d’ « applications blanches » servant de base de développement aux équipes projet d'EDF."
      },
      boiron: {
        title: "Boiron (Décembre 2015 - Juillet 2017)",
        description:
          "Participation aux développements des différentes applications de gestion du SI Boiron. La majeure partie des applications sont des clients lourds avec un front-end en Swing et un back-end Java JEE. Quelques applications en technologie AngularJS. Les applications sont variées : commandes, entrepôts, tarifs, clients…"
      },
      biomerieux: {
        title: "Biomérieux (Mars 2015 - Décembre 2015)",
        description:
          "Participation aux développements des différents composants de la version V6 de Myla en Java JEE, REST et GWT. Myla est solution informatique qui permet de connecter différents instruments d’analyse au Système Informatique du Laboratoire (SIL)."
      },
      sncf: {
        title: "SNCF (Mai 2014 - Mars 2015)",
        description:
          "Paramétrage et développement des nouveaux objets métiers au sein du progiciel EBX5 pour le projet MDM SIRH, rédaction de spécifications techniques depuis les spécifications génériques fournit par la MOA. Administrateur technique de la solution pour la SNCF."
      },
      orange: {
        title: "Orange (Septembre 2012 - Mai 2014)",
        description:
          "Participation aux développements de fonctionnalités sur une application de suivi de commande. Le suivi de sa commande est disponible au client à partir d’une IHM web ; il est réalisé par l’envoi de SMS et de MAILS qui informent le client de l’évolution de sa commande. Grâce à l’IHM conseiller de SuiviCommande, le conseiller peut également renseigner le client sur l’avancement de sa commande (état d’avancement, date de livraison prévue, …)."
      }
    }
  },
  formation: {
    title: "Formation",
    master: {
      title:
        "Diplôme d'Ingénieur - Informatique et Réseaux de Communication (2009 – 2012)",
      school: "Ecole Supérieure de Chimie Physique et Electronique de Lyon",
      sandwichCourse: "Formation en alternance effectuée chez Orange",
      thirdYear: {
        title: "Projet 3ème année",
        description:
          "Projet d’étude de mise en place d’un framework de test d’IHM Web pour un site de consultation de commande :",
        details: {
          "1": "Etude des solutions du marché",
          "2":
            "Création d’une short liste des solutions adéquates (2 solutions retenues : Selenium et QTP d’HP)",
          "3": "POC de chaque solution",
          "4": "Présentation des solutions à l’équipe",
          "5":
            "Mise en place du squelette pour une industrialisation de la solution retenue : Selenium",
          "6": "Soutien aux équipes"
        }
      },
      secondYear: {
        title: "Projet 2ème année",
        description:
          "Participation à la refonte de l’IHM de l’application web de suivi de commande (passage de page en JSP au nouveau framework Wicket) :",
        details: {
          "1": "Montée de compétence sur le framework (POC et formation)",
          "2":
            "Migration vers le nouveau framework des différents composants de l’application dans une équipe réduite",
          "3":
            "Soutien au reste de l’équipe pour appréhender le nouveau framework",
          "4":
            "Participation aux autres développements de l’application en mode SCRUM"
        }
      }
    },
    technicalDegree: {
      title: "DUT Informatique (2007 – 2009)",
      school: "IUT 2 de Grenoble"
    },
    highSchool: {
      title: "Baccalauréat Scientifique, option Mathématiques (2004 – 2007)",
      school: "Lycée Camille Sée de Colmar"
    }
  },
  competences: {
    title: "Compétences",
    technicalSkills: "Compétences techniques",
    otherSkills: "Autres compétences"
  },
  hobbies: {
    title: "Loisirs",
    photography: "Photographie",
    sports: "Sports",
    bouldering: "Escalade",
    tennis: "Tennis",
    padel: "Padel",
    squash: "Squash",
    badminton: "Badminton",
    foot: "Football",
    running: "Course à pied",
    swim: "Natation"
  },
  details: {
    vuejs: "VueJS",
    nestjs: "NestJS",
    websockets: "WebSockets",
    openshift: "Openshift",
    java: "Java",
    jsp: "JSP",
    angularjs: "AngularJS",
    maven: "Maven",
    spring: "Spring",
    hibernate: "Hibernate",
    oracle: "Oracle",
    quarkus: "Quarkus",
    scrummaster: "Scrum Master",
    english: "Anglais",
    mongodb: "MongoDB",
    typescript: "TypeScript",
    ux: "UX",
    ds: "Design System",
    rational: "Rational",
    couchbase: "Couchbase",
    couchbasemobile: "Couchbase Mobile",
    angular: "Angular",
    springboot: "Spring Boot",
    scrum: "SCRUM",
    cordova: "Cordova",
    yeoman: "Yeoman",
    git: "Git",
    swing: "Swing",
    gwt: "GWT",
    mdm: "MDM EBX 5",
    xsd: "XSD",
    wicket: "Wicket",
    ajax: "Ajax",
    docker: "Docker",
    gitlab: "Gitlab",
    cicd: "CI/CD",
    teamSpirit: "Sens du collectif",
    audacity: "Audace",
    curiosity: "Curiosité",
    entrepeneurShip: "Esprit d'entreprendre"
  }
};
